import React from 'react';
import './Industries.css';

const industries = [
  { name: 'Retail & eCommerce', note: 'Catalogs, checkout, and store operations' },
  { name: 'Healthcare', note: 'Portals, scheduling, and role-based access' },
  { name: 'Education & eLearning', note: 'Learning apps and admin platforms' },
  { name: 'Logistics & Distribution', note: 'Field apps and tracking workflows' },
  { name: 'Finance & Insurance', note: 'Dashboards and secure client portals' },
  { name: 'Real Estate', note: 'Listings, CRM, and agent tools' },
  { name: 'Travel & Hospitality', note: 'Booking flows and guest apps' },
  { name: 'SaaS & Technology', note: 'Multi-tenant products and APIs' },
];

const Industries = () => (
  <section className="industries-section section">
    <div className="container">
      <p className="eyebrow" style={{ display: 'block', textAlign: 'center' }}>Industries</p>
      <h2 className="section-title">Industries we serve</h2>
      <p className="section-subtitle">
        We build for operators in these sectors: web platforms, mobile apps, and the growth work around them.
      </p>
      <div className="industries-grid">
        {industries.map((industry) => (
          <article key={industry.name} className="industry-card">
            <h3>{industry.name}</h3>
            <p>{industry.note}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Industries;
